<p-menu #versionMenu [model]="versionMenuItems()" [popup]="true" [appendTo]="'body'" styleClass="version-menu" />
<span class="yllw-quote-toolbar__version-btn" (click)="versionMenu.toggle($event)">
    <i [class]="versionStatusIcon() + ' ' + versionStatusColorClass()"></i>
    <span>{{ versionNameTruncated() }}</span>
    <i class="pi pi-chevron-down yllw-quote-toolbar__version-chevron"></i>
    <app-kbd-shortcut [keys]="SHORTCUTS.VERSION_MENU" size="sm" (pressed)="toggleVersionMenu()" />
</span>
